import { makeStyles } from 'tss-react/mui';
import { spacing, colors, fontSizes } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    discountModal: {
        '& .MuiPaper-root': {
            width: '335px',
            height: 'auto',
            borderRadius: '0',
            [theme.breakpoints.up('sm')]: {
                width: '308px',
            },
            [theme.breakpoints.up('md')]: {
                width: '467px',
            },
            [theme.breakpoints.up('lg')]: {
                width: '595px',
            },
            [theme.breakpoints.up('xl')]: {
                width: '792px',
            },
        },
        '& header': {
            display: 'none',
        },
        '& .MuiDialogContent-root': {
            padding: '0',
        },
    },
    imageSection: {
        width: '100%',
        margin: 0,
        padding: 0,
        flexShrink: 0,
        '& img': {
            position: 'static !important', // !important is used to override Next.js Image component's absolute positioning (fill={true})
            // to allow the image to maintain its natural flow and aspect ratio within the flex container
        },
    },
    promoImage: {
        width: '100%',
        height: 'auto',
        display: 'block',
        backgroundColor: 'transparent',
        margin: 0,
        padding: 0,
    },
    contentSection: {
        display: 'flex',
        flexDirection: 'column',
        padding: spacing.medium,
        [theme.breakpoints.between('sm', 'md')]: {
            paddingTop: spacing.medium,
            paddingBottom: spacing.medium,
            paddingLeft: theme.spacing(1.5),
            paddingRight: theme.spacing(1.5),
        },
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(4),
        },
    },
    headerSection: {
        display: 'flex',
        alignItems: 'flex-start',
        marginBottom: spacing.xs,
        '& > :not(:last-child)': {
            marginRight: spacing.xs,
        },
        [theme.breakpoints.up('md')]: {
            marginBottom: spacing.small,
        },
    },
    successIcon: {
        color: colors.siteNoticeColor.GREEN, // Success green
        fontSize: fontSizes.xl,
        flexShrink: 0,
        marginTop: '2px',
        [theme.breakpoints.up('md')]: {
            marginTop: spacing.xxs,
        },
    },
    title: Object.assign(Object.assign({}, theme.typography.medium_bold), { marginTop: '2px', [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.large_bold), { marginTop: spacing.xxs }) }),
    message: Object.assign(Object.assign({}, theme.typography.small_regular), { marginBottom: spacing.small }),
    continueButton: {
        '&.MuiButtonBase-root.MuiButton-root': {
            padding: `15px ${spacing.medium} 13px`,
        },
        width: '287px',
        '& span': Object.assign({}, theme.typography.small_button),
    },
}));
export default useStyles;
